module.exports = __webpack_public_path__ + "img/step3.8b155efb.webp";